<div class="module-taskbar" [hidden]="!modules.length || !this.activeDashboard.key">
    <div class="module-taskbar-item"
        *ngFor="let module of modules; let $index = index"
        [attr.id]="'module-taskbar-item-' + $index"
        (click)="restoreModule($index, module.moduleKey)">
        <span class="txtOverflow">{{ module.CustomName }}</span>
        <svg [attr.id]="'module-taskbar-menu-' + $index"
            class="fill-valyrianSteel fill-hover-whaleTail mt-2 ml-1"
            style="height: 14px; width: 14px;"
            (click)="openMenu(module.moduleKey, $event)">
            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
        </svg>
    </div>
</div>

<div class="dropup">
    <div #dropdownMenu
        class="dropdown-menu taskbar-dropup-menu"
        role="menu"
        style="position: absolute; bottom: 40px;"
        [style.left]="menuPosition + 'px'"
        [class.show]="menuOpened">
        <a href="#" id="moduleTaskbar-deleteModule" class="dropdown-item taskbar-popover" (click)="deleteModule(menuOpened)">
            <svg class="icon-16 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
            <span cvLocalizedText langSection="Module_Menu" langKey="Delete">Delete</span>
        </a>
    </div>
</div>
